/** URL de retorno para emails de recovery. Siempre usa el origen actual (localhost en dev, prod en prod). */
export function getPasswordResetUrl(): string {
  return `${window.location.origin.replace(/\/$/, '')}/reset-password`;
}

export function isRecoveryCallback(): boolean {
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  const hashParams = new URLSearchParams(hash);
  if (hashParams.get('type') === 'recovery') {
    return true;
  }
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('type') === 'recovery';
}

/** Instrucciones si Supabase redirige a prod por URL no permitida. */
export function getLocalRecoverySetupHint(redirectUrl: string): string {
  return `El enlace debería abrir: ${redirectUrl}. Si te manda a producción, agregá esa URL (o http://localhost:3000/**) en Supabase → Authentication → URL Configuration → Redirect URLs.`;
}
